import { imsAuthService } from "./ims-auth-service";
import { getSafeReturnUrl } from "./return-url";

const AUTO_SIGN_IN_STARTED_AT_KEY = "ekocrop-auto-sign-in-started-at";
const AUTO_SIGN_IN_COOLDOWN_MS = 60_000;

const readAutoSignInStartedAt = (): number => {
  try {
    return Number(window.sessionStorage.getItem(AUTO_SIGN_IN_STARTED_AT_KEY)) || 0;
  } catch (error) {
    console.warn("Auto sign-in guard storage is unavailable", error);
    return 0;
  }
};

const writeAutoSignInStartedAt = (startedAt: number | null): void => {
  try {
    if (startedAt === null) {
      window.sessionStorage.removeItem(AUTO_SIGN_IN_STARTED_AT_KEY);
    } else {
      window.sessionStorage.setItem(AUTO_SIGN_IN_STARTED_AT_KEY, String(startedAt));
    }
  } catch (error) {
    console.warn("Auto sign-in guard storage is unavailable", error);
  }
};

export const startSignIn = (returnUrl?: string | null): void => {
  imsAuthService.redirectToLogin(getSafeReturnUrl(returnUrl));
};

export const startAutoSignIn = (returnUrl?: string | null): boolean => {
  const now = Date.now();
  if (now - readAutoSignInStartedAt() < AUTO_SIGN_IN_COOLDOWN_MS) {
    return false;
  }
  writeAutoSignInStartedAt(now);
  startSignIn(returnUrl);
  return true;
};

export const resetAutoSignIn = (): void => {
  writeAutoSignInStartedAt(null);
};
